import { errorId } from "@/lib/formErrors";
import { cn } from "@/lib/utils";

/**
 * The message under a box that was refused. Renders nothing when there is none, so it
 * can sit under every field unconditionally. `role="alert"` announces it when it appears.
 */
export function FieldError({ field, errors, className }) {
  const message = errors?.[field];
  if (!message) return null;
  return (
    <p id={errorId(field)} role="alert" data-testid={`error-${field}`}
       className={cn("text-xs text-destructive-text mt-1", className)}>
      {message}
    </p>
  );
}

/** The class a box wears while its message shows. */
export const invalidClass = (errors, field) => (errors?.[field] ? "border-destructive focus-visible:ring-destructive" : "");
